"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.VERTICAL = exports.PERCENT_FULL = exports.PERCENT_EMPTY = exports.HORIZONTAL = void 0;
function cov_292tpjns2o() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/RangeSlider/lib/constants.js";
  var hash = "4dd0af6c1c1a0d5d3c579da3eb82c286e3626303";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/RangeSlider/lib/constants.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 26
        },
        end: {
          line: 1,
          column: 38
        }
      },
      "1": {
        start: {
          line: 2,
          column: 24
        },
        end: {
          line: 2,
          column: 34
        }
      },
      "2": {
        start: {
          line: 3,
          column: 29
        },
        end: {
          line: 3,
          column: 30
        }
      },
      "3": {
        start: {
          line: 4,
          column: 28
        },
        end: {
          line: 4,
          column: 31
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4dd0af6c1c1a0d5d3c579da3eb82c286e3626303"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_292tpjns2o = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_292tpjns2o();
var HORIZONTAL = exports.HORIZONTAL = (cov_292tpjns2o().s[0]++, 'HORIZONTAL');
var VERTICAL = exports.VERTICAL = (cov_292tpjns2o().s[1]++, 'VERTICAL');
var PERCENT_EMPTY = exports.PERCENT_EMPTY = (cov_292tpjns2o().s[2]++, 0);
var PERCENT_FULL = exports.PERCENT_FULL = (cov_292tpjns2o().s[3]++, 100);